// Environment-specific values resolve in this order:
//   1. window._env_        — written at container start by
//                             scripts/generate-env-config.js from the App
//                             Service Application Settings (see DEPLOYMENT.md)
//   2. process.env         — CRA vars baked in at build time:
//        .env              — defaults for everyone (currently TEST / QA)
//        .env.production   — overrides applied by `npm run build` (PROD)
//        .env.local        — gitignored personal overrides
//   3. Literal defaults    — TEST / QA values so a misconfigured build
//                             can't accidentally talk to prod.
//
// CRA only inlines process.env.REACT_APP_* when written out literally, so the
// process.env lookups below must stay as explicit member accesses.

const env = (typeof window !== "undefined" && window._env_) || {}
const cfg = (key, baked, fallback) => env[key] || baked || fallback

const BASE_SERVICE_URL = cfg("REACT_APP_SERVICE_URL", process.env.REACT_APP_SERVICE_URL, "https://api-test.estorelogistics.com.au")

export const SettingConstant = {
  TOKEN_EXPIRED_MINUTES: 60,
  APP_VERSION: cfg("REACT_APP_VERSION", process.env.REACT_APP_VERSION, "2.1.3"),
  // Env values are strings — only an explicit "false" turns event logging off.
  SHOULD_LOG_EVENTS: cfg("REACT_APP_SHOULD_LOG_EVENTS", process.env.REACT_APP_SHOULD_LOG_EVENTS, "true").toLowerCase() !== "false",

  GA_MEASUREMENT_ID: cfg("REACT_APP_GA_MEASUREMENT_ID", process.env.REACT_APP_GA_MEASUREMENT_ID, "G-PBT96QFNZ9"),
  SUBCRIPTION_KEY: cfg("REACT_APP_SUBSCRIPTION_KEY", process.env.REACT_APP_SUBSCRIPTION_KEY, "bdf30cdd0b094439bd61c3c503eda3f3"),
  CLIENT_ID: cfg("REACT_APP_CLIENT_ID", process.env.REACT_APP_CLIENT_ID, "19eff4eb-c805-4b5b-a535-1fce9a1aef2c"),
  CLIENT_SECRET_VALUE: cfg("REACT_APP_CLIENT_SECRET", process.env.REACT_APP_CLIENT_SECRET, "wnA8Q~8qRpVJSw2LHQiAkPtZ-sZ~euqmb.Qh0cVM"),
  CUSTOM_FONT_URL: cfg("REACT_APP_CUSTOM_FONT_URL", process.env.REACT_APP_CUSTOM_FONT_URL, "https://use.typekit.net/atn4rti.css"),

  TENANT: "estorelogisticsb2c",
  POLICY: "B2C_1_API_SignIn",
  CODE_VERIFIER: "CODE_VERIFIER",
  TOKEN_DATA: "TOKEN_DATA",
  CLIENT_SECRET: "CLIENT_DATA",

  UAM_SERVICE_URL: `${BASE_SERVICE_URL}/uam/v1/`,
  APP_SERVICE_URL: `${BASE_SERVICE_URL}/api/v1/`,
  DASHBOARD_SERVICE_URL: `${BASE_SERVICE_URL}/dashboards/v1/`,

  UPLOAD_HISTORY_URL: cfg("REACT_APP_UPLOAD_HISTORY_URL", process.env.REACT_APP_UPLOAD_HISTORY_URL, "https://qa-uploadhistory-esl.azurewebsites.net/api/"),
}
